import { writable } from "./svelte";

/**
 * 
 */
export class FocusDirectionStore {
	/**
	 * @param {HTMLElement|Window|Document|ShadowRoot} element 
	 */
	constructor(element) {
		/** @type {import('../public').DirectionAxis1} */
		this.dir = "";

		const onKeyDown = (/** @type {(value: string) => void} */ set) => (/** @type {Event} */ ev) => {
			const e = /** @type {KeyboardEvent} */ (ev);
			const isTab = e.key === 'Tab';
			if (isTab) {
				this.dir = e.shiftKey ? 'previous' : 'next';
				set(this.dir);
			}
		}
		this.onKeyDown = onKeyDown;

		const { subscribe } = writable("", set => {
			set("");
			element?.addEventListener('keydown', onKeyDown(set));

			return () => {
				element?.removeEventListener('keydown', onKeyDown(set));
			}
		});

		this.subscribe = subscribe;
	}
}

export const directionStore = new FocusDirectionStore(window);

export default directionStore;